import React from 'react';
import {
  FiMessageCircle,
  FiPenTool,
  FiCode,
  FiRefreshCw,
  FiSmartphone,
  FiZap,
  FiSearch,
  FiLock,
  FiEdit3,
  FiHeadphones,
  FiHeart,
  FiClock,
  FiUsers,
} from 'react-icons/fi';
import { FaEuroSign } from 'react-icons/fa';
import { IconType } from 'react-icons';

/** Central registry so data (db.ts) can reference icons by string key. */
const registry: Record<string, IconType> = {
  // process
  chat: FiMessageCircle,
  sketch: FiPenTool,
  build: FiCode,
  refresh: FiRefreshCw,
  // features
  phone: FiSmartphone,
  gauge: FiZap,
  search: FiSearch,
  lock: FiLock,
  pencil: FiEdit3,
  support: FiHeadphones,
  // trust
  heart: FiHeart,
  clock: FiClock,
  euro: FaEuroSign,
  handshake: FiUsers,
};

export const getIcon = (key: string): React.ReactElement => {
  const Icon = registry[key] ?? FiHeart;
  return <Icon aria-hidden="true" />;
};
